
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import { Link } from "react-router";
import { getSwarmSubscriptionRequestFavoriteCompetitions } from "../../../helpers/terminalRequests/favoriteCompetitions";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import { getFavoriteCompetitionsSubscriptionData } from '../../../helpers/favoriteCompetitionHelpers';
import Loader from "../loader";
import PropTypes from "prop-types";
import Config from "../../../config/main";

class FavoriteCompetitions extends Component {
    render() {
        let { data, fromHomePage } = this.props;

        return data ? [
            Config.homePageHorseRacing && <Link to={`/horseRacing`} className="horseRacing">
                <p>
                    <span>
                        <b className={`flag-view-m icon-ireland`} />Ireland
                    </span>
                    <i>Irish Stallion Farms EBF Maiden</i>
                </p>
            </Link>,
            data.sort((a, b) => a.favorite_order - b.favorite_order)
                .map(comp => Config.favoriteCompetitionsScroll ? <Link key={comp.id} to={`/prematch/${comp.sportAlias}/${comp.regionId}/all?fromHomePage=${fromHomePage}`} className={`${comp.regionAlias.toLowerCase()} competition-id-${comp.id}`}>
                    <p>
                        {Config.favoriteCompetitionRegion ? <>
                            <span>
                                <b className={`flag-view-m icon-${comp.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{comp.regionName}
                            </span>
                            <i>{comp.name}</i>
                        </> : <span>
                            <b className={`flag-view-m icon-${comp.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{comp.name}
                        </span>}
                    </p>
                </Link> : <Link key={comp.id} to={`/prematch/${comp.sportAlias}/${comp.regionId}/all?fromHomePage=${fromHomePage}`} className={`${comp.regionAlias.toLowerCase()} competition-id-${comp.id}`}>
                    <p>
                        {Config.favoriteCompetitionRegion ? <>
                            <span>
                                <b className={`flag-view-m icon-${comp.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{comp.regionName}
                            </span>
                            <i>{comp.name}</i>
                        </> : <span>
                            <b className={`flag-view-m icon-${comp.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{comp.name}
                        </span>}
                    </p>
                </Link>)
        ] : <Loader />;
    }
}

FavoriteCompetitions.propTypes = {
    data: PropTypes.array
};

const mapStateToProps = () => {
    let selectorKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestFavoriteCompetitions());
    return getFavoriteCompetitionsSubscriptionData(selectorKey);
};

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: FavoriteCompetitions,
        ComponentWillMount: function () {
            this.swarmSubscriptionRequest = getSwarmSubscriptionRequestFavoriteCompetitions();
            this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestFavoriteCompetitions());
            this.keepDataAfterUnsubscribe = true;
        }
    }
));